<template>
     <div class="flex flex-wrap flex-row mt-0 mb-2">
        <div class="w-1/2 pt-2 text-lg pl-1 mb-3">
            Horarios
        </div>
        <!-- Select Turno -->
        <!-- <div class=" mb-2 px-0"> -->
        <div class="w-full bg-gray-100 py-3 rounded-md shadow-md" >
          <span class="ml-2 mr-2">Turno</span>
          <select v-model="selectedShift" class="w-32 mr-3 py-1 px-3 h-8 text-sm rounded border border-gray-300">
            <option v-for="shift in shifts" :key="shift.id" :value="shift.id">
              {{ shift.name }}
            </option>
          </select>

          <span class="ml-3">Curso</span>
          <select v-model="selectedCourse" class="w-32 ml-3 py-1 px-3 h-8 text-sm rounded border border-gray-300">
            <option v-for="course in courses" :key="course.id" :value="course.id">
                {{ course.course }} - {{ course.division }}
            </option>
          </select>

          <span class="ml-3">Asignatura</span>
          <select
            v-model="selectedSubject"
            class="w-64 ml-3 py-1 px-3 h-8 text-sm rounded border border-gray-300"
          >
            <option value="all" :selected="!subjects || subjects.length == 0 ? true : false" >Todas</option>
            <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
                {{ subject.name }}
            </option>
          </select>

          <span class="ml-3">Profesor</span>
          <select
            v-model="selectedTeacher"
            class="w-64 ml-3 py-1 px-3 h-8 text-sm rounded border border-gray-300"
          >
            <option value="all">Todos</option>
            <option v-for="teacher in teachers" :key="teacher.User.id" :value="teacher.User.id">
              {{ teacher.Profile.lastname }}, {{ teacher.Profile.firstname }}
            </option>
          </select>
        </div>

        <!-- Select Curso
        <div class="w-full md:w-1/4 px-2">

        </div> -->

         <!-- Select Subject -->
         <!-- <div class="w-full md:w-1/3 px-2">

        </div> -->
     </div>

     <!-- Table -->
     <div v-if="!dataComplete && getScheduleStatus">
      <Loading />
     </div>
     <div v-else>
      <div class="table-responsive" v-if="dataComplete && selectedCourse">
        <table class="min-w-full">
          <thead>
                <tr>
                  <!-- <th class="px-6 py-3 text-xs font-solid leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                      Horario
                  </th> -->
                  <th v-for="day in days" :key="day.id" scope="col" class="px-3 py-3 text-xs font-solid leading-4 tracking-wider text-left  text-gray-100 uppercase border-b border-gray-200 bg-indigo-800">
                      {{ day.name }}
                  </th>
              </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-for="(row, index) in rowsSchedules" :key="index" class="">
              <td class="px-3 py-2 whitespace-nowrap align-top">
                <div v-if="showScheduleCell(0, index)"
                  class="py-2 px-4 border border-gray-300 font-bold hover:bg-violet-100">
                    <div class="py-0 px-0 font-bold flex justify-start">
                      <span
                        class="cursor-pointer text-gray-400 hover:text-gray-500"
                        @click="showModalScheduleEdit(0, index)"
                      >
                        {{ data[0].schedules.find( (s, i) => i == index).description }}
                      </span>
                      <i
                        @click="showModalScheduleEdit(0, index)"
                        class="fa-solid fa-pen ml-4 cursor-pointer text-gray-400 hover:text-gray-500">
                      </i>
                    </div>

                    <!-- Contenedor de Profesor y asignatura -->
                    <div class=" text-xs" v-if="subjectsSelectable.find( s => s.id == data[0].schedules.find( (s, i) => i == index).classes_subjects_id)">
                      <div  class="my-1" v-if="subjectsSelectable.find( s => s.id == data[0].schedules.find( (s, i) => i == index).classes_subjects_id)">
                          {{ subjectsSelectable.find( s => s.id == data[0].schedules.find( (s, i) => i == index).classes_subjects_id).subject.name }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>
                      <div class="mt-1 mb-1">Profesor</div>
                      <div  class="my-1 text-sm" v-if="teachers.find( t => t.User.id == data[0].schedules.find( (s, i) => i == index).user_id)">
                          {{ teachers.find( t => t.User.id == data[0].schedules.find( (s, i) => i == index).user_id).Profile.lastname }},
                          {{ teachers.find( t => t.User.id == data[0].schedules.find( (s, i) => i == index).user_id).Profile.firstname }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>
                    </div>
                    <div v-else>

                    </div>
                  </div>
              </td>

              <td class="px-3 py-2 whitespace-nowrap align-top">
                <div v-if="showScheduleCell(1, index)"
                  class="py-2 px-4 border border-gray-300 font-bold hover:bg-violet-100">
                    <div class="py-0 px-0 font-bold flex justify-start">
                      <span
                        class="cursor-pointer text-gray-400 hover:text-gray-500"
                        @click="showModalScheduleEdit(1, index)"
                      >
                        {{ data[0].schedules.find( (s, i) => i == index).description }}
                      </span>
                      <i
                        @click="showModalScheduleEdit(1, index)"
                        class="fa-solid fa-pen ml-4 cursor-pointer text-gray-400 hover:text-gray-500">
                      </i>
                    </div>

                    <!-- Contenedor de Profesor y asignatura -->
                    <div class=" text-xs" v-if="subjectsSelectable.find( s => s.id == data[1].schedules.find( (s, i) => i == index).classes_subjects_id)">
                      <div  class="my-1" v-if="subjectsSelectable.find( s => s.id == data[1].schedules.find( (s, i) => i == index).classes_subjects_id)">
                          {{ subjectsSelectable.find( s => s.id == data[1].schedules.find( (s, i) => i == index).classes_subjects_id).subject.name }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>

                      <div class="mt-1 mb-1">Profesor</div>
                      <div  class="my-1 text-sm" v-if="teachers.find( t => t.User.id == data[1].schedules.find( (s, i) => i == index).user_id)">
                          {{ teachers.find( t => t.User.id == data[1].schedules.find( (s, i) => i == index).user_id).Profile.lastname }},
                          {{ teachers.find( t => t.User.id == data[1].schedules.find( (s, i) => i == index).user_id).Profile.firstname }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>
                    </div>
                  </div>
              </td>
              <td class="px-3 py-2 whitespace-nowrap align-top">
                <div v-if="showScheduleCell(2, index)"
                  class="py-2 px-4 border border-gray-300 font-bold hover:bg-violet-100">
                    <div class="py-0 px-0 font-bold flex justify-start">
                      <span
                        class="cursor-pointer text-gray-400 hover:text-gray-500"
                        @click="showModalScheduleEdit(2, index)"
                      >
                        {{ data[0].schedules.find( (s, i) => i == index).description }}
                      </span>
                      <i
                        @click="showModalScheduleEdit(2, index)"
                        class="fa-solid fa-pen ml-4 cursor-pointer text-gray-400 hover:text-gray-500">
                      </i>
                    </div>

                    <!-- Contenedor de Profesor y asignatura -->
                    <div class=" text-xs" v-if="subjectsSelectable.find( s => s.id == data[2].schedules.find( (s, i) => i == index).classes_subjects_id)">
                      <div  class="my-1" v-if="subjectsSelectable.find( s => s.id == data[2].schedules.find( (s, i) => i == index).classes_subjects_id)">
                          {{ subjectsSelectable.find( s => s.id == data[2].schedules.find( (s, i) => i == index).classes_subjects_id).subject.name }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>

                      <div class="mt-1 mb-1">Profesor</div>
                      <div  class="my-1 text-sm" v-if="teachers.find( t => t.User.id == data[2].schedules.find( (s, i) => i == index).user_id)">
                          {{ teachers.find( t => t.User.id == data[2].schedules.find( (s, i) => i == index).user_id).Profile.lastname }},
                          {{ teachers.find( t => t.User.id == data[2].schedules.find( (s, i) => i == index).user_id).Profile.firstname }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>
                    </div>
                  </div>

              </td>
              <td class="px-3 py-2 whitespace-nowrap align-top">
                <div v-if="showScheduleCell(3, index)"
                  class="py-2 px-4 border border-gray-300 font-bold hover:bg-violet-100">
                    <div class="py-0 px-0 font-bold flex justify-start">
                      <span
                        class="cursor-pointer text-gray-400 hover:text-gray-500"
                        @click="showModalScheduleEdit(3, index)"
                      >
                        {{ data[0].schedules.find( (s, i) => i == index).description }}
                      </span>
                      <i
                        @click="showModalScheduleEdit(3, index)"
                        class="fa-solid fa-pen ml-4 cursor-pointer text-gray-400 hover:text-gray-500">
                      </i>
                    </div>

                    <!-- Contenedor de Profesor y asignatura -->
                    <div class=" text-xs" v-if="subjectsSelectable.find( s => s.id == data[3].schedules.find( (s, i) => i == index).classes_subjects_id)">
                      <div  class="my-1" v-if="subjectsSelectable.find( s => s.id == data[3].schedules.find( (s, i) => i == index).classes_subjects_id)">
                          {{ subjectsSelectable.find( s => s.id == data[3].schedules.find( (s, i) => i == index).classes_subjects_id).subject.name }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>

                      <div class="mt-1 mb-1">Profesor</div>
                      <div  class="my-1 text-sm" v-if="teachers.find( t => t.User.id == data[3].schedules.find( (s, i) => i == index).user_id)">
                          {{ teachers.find( t => t.User.id == data[3].schedules.find( (s, i) => i == index).user_id).Profile.lastname }},
                          {{ teachers.find( t => t.User.id == data[3].schedules.find( (s, i) => i == index).user_id).Profile.firstname }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>
                    </div>
                  </div>
              </td>
              <td class="px-3 py-2 whitespace-nowrap align-top">
                <div v-if="showScheduleCell(4, index)"
                  class="py-2 px-4 border border-gray-300 font-bold hover:bg-violet-100">
                    <div class="py-0 px-0 font-bold flex justify-start">
                      <span
                        class="cursor-pointer text-gray-400 hover:text-gray-500"
                        @click="showModalScheduleEdit(4, index)"
                      >
                        {{ data[0].schedules.find( (s, i) => i == index).description }}
                      </span>
                      <i
                        @click="showModalScheduleEdit(4, index)"
                        class="fa-solid fa-pen ml-4 cursor-pointer text-gray-400 hover:text-gray-500">
                      </i>
                    </div>

                    <!-- Contenedor de Profesor y asignatura -->
                    <div class=" text-xs" v-if="subjectsSelectable.find( s => s.id == data[4].schedules.find( (s, i) => i == index).classes_subjects_id)">
                      <div  class="my-1" v-if="subjectsSelectable.find( s => s.id == data[4].schedules.find( (s, i) => i == index).classes_subjects_id)">
                          {{ subjectsSelectable.find( s => s.id == data[4].schedules.find( (s, i) => i == index).classes_subjects_id).subject.name }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>

                      <div class="mt-1 mb-1">Profesor</div>
                      <div  class="my-1 text-sm" v-if="teachers.find( t => t.User.id == data[4].schedules.find( (s, i) => i == index).user_id)">
                          {{ teachers.find( t => t.User.id == data[4].schedules.find( (s, i) => i == index).user_id).Profile.lastname }},
                          {{ teachers.find( t => t.User.id == data[4].schedules.find( (s, i) => i == index).user_id).Profile.firstname }}
                      </div>
                      <div  class="my-1" v-else>Sin asignar</div>
                    </div>
                  </div>

              </td>
            </tr>
          </tbody>
        </table>

        <ModalScheduleEdit
          :isVisible="isvisibleModal"
          :data="data"
          :days="days"
          :courses="courses"
          :selectedCourse="selectedCourse"
          :day="day"
          :row="row"
          :teachers="teachers"
          :subjectsSelectable="subjectsSelectable"
          @save="saveSchedule"
          @confirm="saveSchedule"
          @close="closeModal"
          @emptyTeacher="emptyTeacher"
          />
      </div>
    </div>
</template>

<script>
import ModalScheduleEdit from './ModalScheduleEdit.vue'


export default {
  name: 'ScheduleClasses',
  components: { ModalScheduleEdit },
  data() {
    return {
      selectedSubject: 'all',
      selectedTeacher: 'all',
      subjects: [],
      getScheduleStatus: false,
      isvisibleModal: false,
      selectedCourse: null,
      courses: [],
      shifts: [],
      selectedShift: null,
      schedules: [],
      days: [],
      teachers: [],
      userSelected: null,
      classesShifts: [],
      subjectsSelectable: [],
      subjectSelected: null,
      data: [],
      dataComplete: false,
      rowsSchedules: [],
      day: null,
      row: null,
      currentTeacherAndShift: {},
    }
  },
  created() {
    this.getShifts()
    this.getDays()
    this.getTeacher()
  },
  watch: {
    selectedShift() {
        this.getCourses()
    },
    selectedCourse() {
        this.dataComplete = false
        this.getSchedule()
        this.getSubjects()
        //this.getClassesShiftsSchedules()
    },
    selectedSubject(){
      this.dataComplete = false
      if(this.selectedCourse) {
        this.getSchedule()
      }
    },
    selectedTeacher() {
      this.dataComplete = false
      if (this.selectedCourse) {
        this.getSchedule()
      }
    },
  },
  methods: {
    emptyTeacher(detail){
      this.data[detail.day].schedules.find( (s, i) => i == detail.row).user_id = null
    },
    showScheduleCell(dayIndex, rowIndex) {
      const schedule = this.data[dayIndex]?.schedules?.find((s, i) => i == rowIndex)
      if (!schedule) return false

      const classSubject = this.subjectsSelectable.find(
        s => s.id == schedule.classes_subjects_id
      )

      if (this.selectedSubject !== 'all') {
        if (!classSubject || classSubject.subject.id != this.selectedSubject) {
          return false
        }
      }

      if (this.selectedTeacher !== 'all') {
        if (schedule.user_id != this.selectedTeacher) {
          return false
        }
      }

      return true
    },
    applyClassesDaysSubjectsRows(result) {
      const rows = Array.isArray(result) ? result : []
      this.data.forEach(day => {
        day.schedules = day.schedules.map(el => {
          const row = rows.find(
            s => s.days_shifts_schedules_id == el.day_schedule_shift
          )
          return {
            ...el,
            classes_subjects_id: row?.classes_subjects_id,
            user_id: row?.user_id,
            class_days_shifts_schedules_id: row?.id,
          }
        })
      })
      this.getScheduleStatus = false
    },

    getClassesShiftsSchedules() {
      const course = this.selectedCourse
      const shift = this.selectedShift
      const subject = this.selectedSubject

      if (!course || !shift || !this.data.length) {
        this.getScheduleStatus = false
        return
      }

      if (this.selectedTeacher !== 'all') {
        const allowedIds = new Set(this.subjectsSelectable.map(cs => cs.id))
        this.$http
          .get(`/schedules-by-teacher/${this.selectedTeacher}`)
          .then(response => {
            const result = response.data?.data
            const list = Array.isArray(result) ? result : []
            const filtered = list.filter(
              row =>
                row?.classes_subjects_id &&
                allowedIds.has(row.classes_subjects_id)
            )
            this.applyClassesDaysSubjectsRows(filtered)
          })
          .catch(err => {
            console.log(err)
            this.getScheduleStatus = false
          })
        return
      }

      // OpenAPI: subject_id debe existir en `subjects`. No usar el literal "all".
      if (subject === 'all') {
        const subjectIds = [
          ...new Set(
            this.subjectsSelectable.map(cs => cs.subject?.id).filter(Boolean)
          ),
        ]
        if (!subjectIds.length) {
          this.applyClassesDaysSubjectsRows([])
          return
        }
        Promise.all(
          subjectIds.map(sid =>
            this.$http.get(
              `/classes-days-subjects-schedules/${course}/${shift}/${sid}`
            )
          )
        )
          .then(responses => {
            const bySlot = new Map()
            for (const res of responses) {
              const list = res.data?.data
              if (!Array.isArray(list)) continue
              for (const row of list) {
                if (
                  row?.days_shifts_schedules_id &&
                  !bySlot.has(row.days_shifts_schedules_id)
                ) {
                  bySlot.set(row.days_shifts_schedules_id, row)
                }
              }
            }
            this.applyClassesDaysSubjectsRows(Array.from(bySlot.values()))
          })
          .catch(err => {
            console.log(err)
            this.getScheduleStatus = false
          })
        return
      }

      this.$http
        .get(`/classes-days-subjects-schedules/${course}/${shift}/${subject}`)
        .then(response => this.applyClassesDaysSubjectsRows(response.data?.data))
        .catch(err => {
          console.log(err)
          this.getScheduleStatus = false
        })
    },

    closeModal(){

        //Si cancela en modal y antes de editar tenia guardado un profesor y asignatura
        if(this.currentTeacherAndShift.classes_subjects_id && this.currentTeacherAndShift.user_id) {
          this.data[this.day].schedules.find( (s, i) => i == this.row).user_id = this.currentTeacherAndShift.user_id
          this.data[this.day].schedules.find( (s, i) => i == this.row).classes_subjects_id = this.currentTeacherAndShift.classes_subjects_id
        } else {
          this.data[this.day].schedules.find( (s, i) => i == this.row).user_id = null
          this.data[this.day].schedules.find( (s, i) => i == this.row).classes_subjects_id = null
        }
        this.isvisibleModal = false
    },
    saveSchedule(){
        this.isvisibleModal = false
        let schedule = this.data[this.day].schedules.find( (s, i) => i == this.row)
        console.log("schedule", schedule)
        const payload = {
          classes_subjects_id: schedule.classes_subjects_id,
          days_shifts_schedules_id: schedule.day_schedule_shift,
          user_id: schedule.user_id,
        }

        if (schedule.class_days_shifts_schedules_id) {
          this.$http.put(
            `/classes-days-subjects/${schedule.class_days_shifts_schedules_id}`,
            payload
          )
          .then(response => {
            console.log('result..', response.data.data)
            this.getClassesShiftsSchedules()
          })
        } else {
          this.$http.post(`/classes-days-subjects`, payload)
          .then(response => {
            console.log('result..', response.data.data)
            this.getClassesShiftsSchedules()
          })
        }


    },
    showModalScheduleEdit(day, row) {
      this.day = day
      this.row = row
      this.currentTeacherAndShift.class_days_shifts_schedules_id = this.data[day].schedules.find( (s, i) => i == row).class_days_shifts_schedules_id
      this.currentTeacherAndShift.user_id = this.data[day].schedules.find( (s, i) => i == row).user_id
      this.currentTeacherAndShift.classes_subjects_id = this.data[day].schedules.find( (s, i) => i == row).classes_subjects_id
      this.isvisibleModal = true
    },

    createDataInitial() {
        this.rowsSchedules = []
        this.data = []

        this.days.forEach(day => {
          this.data.push({
            id: day.id,
            name: day.name,
          })
        })
        let total = 0;
        this.days.forEach(day => {
          const itemsFound = this.schedules.filter(el => el.day_id == day.id && el.shift_id == this.selectedShift).length

          if(itemsFound && itemsFound > total) {
              total = itemsFound
          }
        })

        for (let i = 0; i < total; i++) {
          this.rowsSchedules.push(i+1)
        }

        this.data.forEach(day => {
          day.schedules = this.schedules.filter( s => s.day_id == day.id && s.shift_id == this.selectedShift).map( el => {
              return {
                  ...el.Schedule,
                  user_id: null,
                  subject_id: null,
                  classes_subjects_id: null,
                  day_schedule_shift: el.id,
                  day_id: day.id,
                  shift_id: this.selectedShift,
              }
          })

        })
        this.dataComplete = true
    },
    getClassByShift() {
      this.$http.get(`/classes/${this.selectedShift}/subjects`).then(response => {
        this.classesShifts = response.data.data
      })
    },
    getTeacher() {
      this.$http
        .get('/roles')
        .then(res => {
          const rawRoles = res.data?.data ?? res.data
          const roles = Array.isArray(rawRoles) ? rawRoles : []
          const roleTeacher = roles.find(r => r.name == 'teacher')
          const role_teacher_id = roleTeacher?.id
          if (!role_teacher_id) return

          this.$http
            .get('/user-by-role-id/' + role_teacher_id)
            .then(response => {
              const raw = response.data?.data ?? response.data ?? []
              this.teachers = Array.isArray(raw) ? raw : []
            })
            .catch(err => console.log(err))
        })
        .catch(err => console.log(err))

      // // this.$http.get('/user-by-role-id/2vtyAQgjKyQJ8tr2UtIAxSskay3').then(response => {
      // //   this.teachers = response.data.data
      // // })
    },

    getSubjects() {
      this.selectedSubject = 'all'
      this.$http.get('/subjects-by-class_id/' + this.selectedCourse).then(response => {
        this.subjects = response.data.data
      })
      .catch( err => console.log(err))
    },
    getDays() {
      this.$http.get('/days').then(response => {
        this.days = response.data.data
      })
    },
    getCourses() {
        this.courses = []
        this.selectedCourse = null
        this.selectedSubject = 'all'
        this.selectedTeacher = 'all'
        if(this.selectedShift) {
            this.getClassByShift()
            this.$http.get(`/classes/${this.selectedShift}`)
            .then(response => {
                this.courses = response.data.data
            })
        } else {
          this.courses = []
        }
    },
    getShifts() {
      this.$http.get('/shifts').then(response => {
        this.shifts = response.data.data
      })
    },
    async getSchedule() {

        if(this.selectedShift) {
            this.getScheduleStatus = true
            this.subjectsSelectable = this.classesShifts.filter( c => c.class_id == this.selectedCourse)

            this.$http.get(`/schedules-day-by-shift/${this.selectedShift}`)
            .then(response => {
              this.schedules = response.data.data
              this.createDataInitial()
              //setTimeout(() => {
                this.getClassesShiftsSchedules()
              //}, 1000)
            })

        } else {
          this.schedules = []
        }
    },
  },
}
</script>
